import { frontendURL } from '../../../helper/URLHelper';
import KnowledgeBaseIndex from './Index.vue';

// consoleTab：kernel 嵌入页直落页签（?tab=）；consoleTabs：限定可见页签范围（?tabs=）。
// 知识库入口 = AI 运营三页签；用量与账单 / 角色与权限是账户级管理，从「设置」侧栏独立进入。
const consoleMeta = (consoleTab, consoleTabs) => ({
  permissions: ['administrator'],
  consoleTab,
  ...(consoleTabs ? { consoleTabs } : {}),
});

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/knowledge-base'),
      name: 'knowledge_base_index',
      component: KnowledgeBaseIndex,
      meta: consoleMeta('kb', 'kb,persona,quality'),
    },
    {
      path: frontendURL('accounts/:accountId/settings/usage-billing'),
      name: 'agent_console_usage_billing',
      component: KnowledgeBaseIndex,
      meta: consoleMeta('billing', 'billing'),
    },
    {
      path: frontendURL('accounts/:accountId/settings/agent-roles'),
      name: 'agent_console_roles',
      component: KnowledgeBaseIndex,
      meta: consoleMeta('roles', 'roles'),
    },
  ],
};
